export const isNewUserQuery = `
  query isNewUserQuery {
    isNewUser
  }
`;
